/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * An enumeration of all the models supported in LUIS.
 */
export enum ModelType {
    Intent = 0,
    Simple = 1,
    Prebuilt = 2,
    Hierarchical = 3,
    Composite = 4,
    List = 5,
    HierarchicalChild = 6,
    PatternAny = 7,
    Regex = 8,
    Role = 100
}
